export const COMMON_CURRENCY_FEATURE_KEY = 'common.currency';
